/** Detect the visitor's IANA timezone (e.g. "America/Los_Angeles") from the browser. */
export function detectTimezone(): string | null {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz && tz.length > 0 && tz.length <= 100 ? tz : null;
  } catch {
    return null;
  }
}
